import * as React from 'react';

import config from 'js/app/config';
import Imgix from 'js/lib/imgix';

class FrontPageGoogleSchemaMarkup extends React.PureComponent {
  render() {
    const markupJson = {
      '@context': 'http://schema.org',
      '@id': `${config.url.base}#organization`,
      '@type': 'Organization',
      name: 'Coursera',
      url: `${config.url.base}`,
      logo: Imgix.processImage('https://coursera.s3.amazonaws.com/media/coursera-rebrand-logo-square.png'),
      sameAs: [
        'https://www.wikidata.org/wiki/Q499962',
        'https://www.instagram.com/coursera/',
        'https://www.youtube.com/user/coursera',
        'https://twitter.com/coursera',
        'https://www.linkedin.com/company/coursera',
        'https://www.facebook.com/Coursera',
      ],
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(markupJson)}
        </script>
      `,
    });

    return (
      <div className="rc-FrontPageGoogleSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default FrontPageGoogleSchemaMarkup;
